import { FETCH_CURRENT_USER } from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_CURRENT_USER
// --------------------------------------------------------------------------
export const fetchCurrentUser = () => ({
  type: FETCH_CURRENT_USER.init,
  payload: API.fetchCurrentUser(),
});

export const fetchCurrentUserSuccess = (data) => ({
  type: FETCH_CURRENT_USER.success,
  payload: data,
});

export const fetchCurrentUserFailure = (error) => ({
  type: FETCH_CURRENT_USER.failure,
  payload: error,
});
